// components/SmartLink/SmartLink.js
import React from 'react';
import NamedLink from '../NamedLink/NamedLink';
import ExternalLink from '../ExternalLink/ExternalLink';

const SmartLink = ({ href, pageName, children, isExternal, ...rest }) => {
  if (isExternal) {
    return (
      <ExternalLink href={href} {...rest}>
        {children}
      </ExternalLink>
    );
  }

  // NamedLink handles internal navigation using `name` and optional `to`
  if (pageName) {
    return (
      <NamedLink name={pageName} {...rest}>
        {children}
      </NamedLink>
    );
  }

  return (
    <ExternalLink href={href} {...rest}>
      {children}
    </ExternalLink>
  );
};

export default SmartLink;
